import { APP_NAME, HOME_TITLE } from 'config';

import React, { Component, PropTypes } from 'react';
import DocumentTitle from 'react-document-title';

export default class Page extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    pageTitle: PropTypes.string,
  }

  render() {
    const {
      children,
      pageTitle,
    } = this.props;

    const finalPageTitle = pageTitle ? `${pageTitle} · ${APP_NAME}` : HOME_TITLE;

    return (
      <DocumentTitle title={finalPageTitle}>
        { children }
      </DocumentTitle>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Page/index.jsx
 **/